import { ModalFullscreen, UIText1, IconClose16, IconButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IModalViewProps {
  isOpened: boolean;
  onClose(): void;
  offersTable: React.ReactElement;
  filters: React.ReactElement;
  offerFromHistory: React.ReactElement;
  title: string;
  moreDetailed: React.ReactNode;
}

export const FullscreenView: React.VFC<IModalViewProps> = ({
  isOpened,
  onClose,
  offersTable,
  filters,
  offerFromHistory,
  title,
  moreDetailed,
}) => {
  return (
    <ModalFullscreen open={isOpened} onClose={onClose} theme="white">
      <div className={styles['container']} data-name="OffersHistoryFullscreenView">
        <header className={styles['header']}>
          <UIText1 fontWeight="bold">{title}</UIText1>
          <IconButton icon={<IconClose16 />} onClick={onClose} aria-label="Закрыть" />
        </header>
        <div className={styles['main']}>
          <div className={styles['listing']} data-name="ListingSection">
            {filters}
            {moreDetailed}
            <div className={styles['table']}>{offersTable}</div>
          </div>
          <div className={styles['offer']} data-name="OfferSection">
            {offerFromHistory}
          </div>
        </div>
      </div>
    </ModalFullscreen>
  );
};
